import { useState } from 'react';
import { Link, NavLink, useLocation } from 'react-router-dom';
import { Menu, X, ArrowUpRight } from 'lucide-react';
import { NAV } from '@/constants/testIds';
import Logo from '@/components/Logo';

const links = [
  { to: '/', label: 'Home', key: 'home' },
  { to: '/platforms', label: 'Platforms', key: 'platforms' },
  { to: '/solutions', label: 'Solutions', key: 'solutions' },
  { to: '/use-cases', label: 'Use Cases', key: 'useCases' },
  { to: '/investments', label: 'Investments', key: 'investments' },
  { to: '/landscape', label: 'Landscape', key: 'landscape' },
  { to: '/about', label: 'About', key: 'about' },
  { to: '/contact', label: 'Contact', key: 'contact' },
];

export const Navbar = () => {
  const [open, setOpen] = useState(false);
  const location = useLocation();

  return (
    <header className="sticky top-0 z-50 border-b border-white/10 bg-black/70 backdrop-blur-xl">
      <div className="px-6 md:px-12 lg:px-16">
        <div className="flex h-20 items-center justify-between">
          <Link
            to="/"
            data-testid={NAV.brand}
            className="group"
            onClick={() => setOpen(false)}
          >
            <Logo variant="amber" size={56} testId="nav-logo" />
          </Link>

          <nav className="hidden lg:flex items-center gap-8">
            {links.map((l) => (
              <NavLink
                key={l.key}
                to={l.to}
                end={l.to === '/'}
                data-testid={NAV.links[l.key]}
                className={({ isActive }) =>
                  `font-mono text-[11px] uppercase tracking-[0.18em] transition-colors ${
                    isActive
                      ? 'text-amber'
                      : 'text-zinc-400 hover:text-white'
                  }`
                }
              >
                {l.label}
              </NavLink>
            ))}
          </nav>

          <div className="hidden lg:flex items-center gap-3">
            <Link
              to="/contact"
              data-testid={NAV.cta}
              className="group inline-flex items-center gap-2 border border-amber bg-amber px-4 py-2 text-xs font-mono uppercase tracking-[0.18em] text-black transition-colors hover:bg-white hover:border-white"
            >
              Partner With Us
              <ArrowUpRight className="h-3.5 w-3.5 transition-transform group-hover:translate-x-0.5 group-hover:-translate-y-0.5" />
            </Link>
          </div>

          <button
            type="button"
            className="lg:hidden grid h-9 w-9 place-items-center border border-white/15 text-white"
            onClick={() => setOpen((v) => !v)}
            data-testid={NAV.mobileToggle}
            aria-label="Toggle menu"
          >
            {open ? <X className="h-4 w-4" /> : <Menu className="h-4 w-4" />}
          </button>
        </div>
      </div>

      {open && (
        <div className="lg:hidden border-t border-white/10 bg-black">
          <div className="px-6 py-6 flex flex-col gap-4">
            {links.map((l) => (
              <NavLink
                key={l.key}
                to={l.to}
                end={l.to === '/'}
                onClick={() => setOpen(false)}
                className={({ isActive }) =>
                  `font-mono text-xs uppercase tracking-[0.18em] ${
                    isActive ? 'text-amber' : 'text-zinc-300'
                  }`
                }
              >
                {l.label}
              </NavLink>
            ))}
            <Link
              to="/contact"
              onClick={() => setOpen(false)}
              className="inline-flex items-center justify-center gap-2 border border-amber bg-amber px-4 py-2 text-xs font-mono uppercase tracking-[0.18em] text-black"
            >
              Partner With Us
              <ArrowUpRight className="h-3.5 w-3.5" />
            </Link>
          </div>
        </div>
      )}
    </header>
  );
};

export default Navbar;
